module.exports = __webpack_public_path__ + "media/images/master-wf-icon-nav-hover-c9f75cc06c41d36f17b310f2d973ec5f.svg";